import React from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import { X } from "lucide-react";
import { mmkBackToMmkButtonStyles } from "./styles";
import { MmkPageShell } from "./mmk-page-shell";

interface QuizLoadingProps {
  onBack?: () => void;
}

export const QuizLoading: React.FC<QuizLoadingProps> = ({ onBack }) => {
  return (
    <MmkPageShell>
      <Box
        sx={{
          position: "relative",
          flex: 1,
          minHeight: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          boxSizing: "border-box",
          pt: { xs: 6, sm: 7 },
          pb: 2,
          px: 3,
        }}
      >
        {onBack && (
          <Button
            variant="outlined"
            onClick={onBack}
            sx={{
              ...mmkBackToMmkButtonStyles,
              position: "absolute",
              top: 0,
              right: 0,
            }}
            startIcon={<X size={18} />}
          >
            Back to MMM
          </Button>
        )}
        <CircularProgress size={48} sx={{ mb: 3 }} />
        <Typography
          variant="h6"
          sx={(theme) => ({
            fontWeight: 600,
            textAlign: "center",
            mb: 1,
            color:
              theme.palette.mode === "dark"
                ? theme.palette.common.white
                : theme.palette.text.primary,
          })}
        >
          Preparing your quiz...
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", textAlign: "center" }}
        >
          Generating 5 questions from your MMM cards
        </Typography>
      </Box>
    </MmkPageShell>
  );
};
